import { useState, useEffect } from 'react'
import s from './Home.scss'
import { withSubscriptionNotification, withHasModules } from 'hocs'
import { PageTitle } from 'components/common/PageTitle'
import { isAdmin } from 'utils/authService'
import { Button, Container, Row, Col } from 'reactstrap'
import { ImTree } from 'react-icons/im'
import { FaUsers, FaCog, FaChartBar } from 'react-icons/fa'
import { AiFillFilePpt } from 'react-icons/ai'
import cn from 'classnames'
import { Link, useNavigate } from 'react-router-dom'
import { DealsModal } from 'components/Deals/DealsModal'
import { useSelector, useDispatch } from 'react-redux'
import { toUsers } from './serializers'
import { makeGetRequest } from 'utils/api'
import { GenerateProposalModal } from 'components/common/modals/GenerateProposal/GenerateProposalModal'
import { ProgressModal } from 'components/common/modals/GenerateProposal/ProgressModal'
import { ContactModalContainer } from 'components/common/modals/ContactModalContainer'
import { CompanyModalContainer } from 'components/common/modals/CompanyModalContainer'

const Home = () => {
  const [isAddDealModalVisible, setIsAddDealModalVisible] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const storedUsers = useSelector(state => state.users.users)
  const [users, setUsers] = useState(toUsers(storedUsers) || [])
  const [isGenerateProposalModalVisible, setIsGenerateProposalVisible] = useState(false)
  const [isProgressModalVisible, setIsProgressModalVisible] = useState(false)
  const [loadingStep, setLoadingStep] = useState('')
  const [isAddContactModalVisible, setIsAddContactModalVisible] = useState(false)
  const [showCompanyModal, setShowCompanyModal] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (users.length) return
      const { content } = await makeGetRequest('/v1/users')
      setUsers(toUsers(content))
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleCompanyModal = () => setShowCompanyModal(!showCompanyModal)

  const navigateTo = path => {
    window.open(path, '_blank')
  }

  const createDeal = (deal, cb) => {
    dispatch({
      type: 'CREATE_DEAL_REQUESTED',
      payload: {
        deal,
        cb,
        fromDashboard: true
      }
    })
  }

  return (
    <>
      <PageTitle view="Home" />
      <section className={s.section}>
        <p className={s.title}>Welcome to iDeal CRM for construction.</p>
        <p className={s.subtitle}>
          Your construction software to manage leads, bids, jobs, opportunities, clients & follow-up
          to <b>win more work.</b>
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            className={s.saveBtn}
            onClick={() => navigateTo('https://calendly.com/ideal-calendar')}
          >
            Meet with Us
          </Button>
          <Button
            className={s.saveBtn}
            onClick={() => navigateTo('https://calendly.com/ideal-calendar')}
          >
            Request a Demo
          </Button>
          <Button className={s.saveBtn} onClick={() => navigateTo('https://idealcrm.app/contact/')}>
            Contact Us
          </Button>
        </div>
        <Container className={s.noPadding}>
          {isAdmin() ? (
            <>
              <Row className={cn(s.managementRow, 'g-0')}>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.management, s.iconCell)}>
                    <ImTree className={s.icon} />
                    <p className={s.description}>Opportunity Management</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Create Opportunities</p>
                      <p onClick={() => setIsAddDealModalVisible(true)} className={s.item}>
                        Add new opportunity
                      </p>
                      <Link to="/opportunities/board" className={s.item}>
                        See existing opportunities
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Opportunity Settings</p>
                      <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                        Opportunity category
                      </Link>
                      <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                        Opportunity source
                      </Link>
                      <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                        Reason for not bidding
                      </Link>
                      <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                        Reason for not winning
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <div className={s.withoutFirstRow}>
                        <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                          Geographical area
                        </Link>
                        <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                          Opportunity health
                        </Link>
                        <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                          Auto quote number
                        </Link>
                        <Link to="/admin?menu=opportunity&tab=organization" className={s.item}>
                          more...
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Pipeline Settings</p>
                      <Link to="/admin?menu=pipeline&tab=organization" className={s.item}>
                        See pipeline stages
                      </Link>
                      <Link to="/admin?menu=pipeline&tab=organization" className={s.item}>
                        Add new pipeline stages
                      </Link>
                      <Link to="/admin?tab=personalSettings" className={s.item}>
                        My pipeline stages
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Data Imports & Exports</p>
                      <Link to="/admin?menu=imports&tab=organization" className={s.item}>
                        Import Opportunities
                      </Link>
                      <Link to="/admin?menu=exports&tab=organization" className={s.item}>
                        Export Opportunities
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className={cn(s.clientsRow, 'g-0')}>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.clients, s.iconCell)}>
                    <FaUsers className={s.icon} />
                    <p className={s.description}>Clients Management</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Clients / Companies</p>
                      <p onClick={toggleCompanyModal} className={s.item}>
                        Add client/company
                      </p>
                      <Link to="/companies" className={s.item}>
                        See existing clients
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Contacts</p>
                      <p onClick={() => setIsAddContactModalVisible(true)} className={s.item}>
                        Add contact
                      </p>
                      <Link to="/contacts" className={s.item}>
                        See existing contacts
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Client Settings</p>
                      <Link to="/admin?menu=company&tab=organization" className={s.item}>
                        Client Type
                      </Link>
                      <Link to="/admin?menu=company&tab=organization" className={s.item}>
                        Client market segment
                      </Link>
                      <Link
                        to="/admin?menu=templates&secondaryTab=email&tab=organization"
                        className={s.item}
                      >
                        Contact email templates
                      </Link>
                      <Link
                        to="/admin?menu=templates&secondaryTab=email&tab=organization"
                        className={s.item}
                      >
                        Follow-up email templates
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="4">
                  <div className={s.cell}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Data Imports & Exports</p>
                      <Link to="/admin?menu=imports&tab=organization" className={s.item}>
                        Import client companies
                      </Link>
                      <Link to="/admin?menu=imports&tab=organization" className={s.item}>
                        Import contacts
                      </Link>
                      <Link to="/companies" className={s.item}>
                        Export client companies
                      </Link>
                      <Link to="/contacts" className={s.item}>
                        Export contacts
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className={cn(s.proposalRow, 'g-0')}>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.proposal, s.iconCell)}>
                    <AiFillFilePpt className={s.icon} />
                    <p className={s.description}>Proposal Management</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Proposals / Tenders</p>
                      <p onClick={() => setIsGenerateProposalVisible(true)} className={s.item}>
                        Create new proposal
                      </p>
                      <Link to="/opportunities/board" className={s.item}>
                        Upload proposal to an existing opportunity
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Proposal Settings</p>
                      <Link
                        to="/admin?menu=templates&secondaryTab=word&tab=organization"
                        className={s.item}
                      >
                        Word proposal templates
                      </Link>
                      <Link
                        to="/admin?menu=templates&secondaryTab=html&tab=organization"
                        className={s.item}
                      >
                        HTML proposal templates
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="6">
                  <div className={s.cell}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Proposal Email</p>
                      <Link
                        to="/admin?menu=templates&secondaryTab=email&tab=organization"
                        className={s.item}
                      >
                        Customize proposal email
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className={cn(s.reportsRow, 'g-0')}>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.reports, s.iconCell)}>
                    <FaChartBar className={s.icon} />
                    <p className={s.description}>Reports</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Sales Reports</p>
                      <Link to="/reports/sales-and-forecast" className={s.item}>
                        YTD + Annual Sales
                      </Link>
                      <Link to="/reports/opportunities-in-forecast" className={s.item}>
                        Opportunities in Forecast
                      </Link>
                      <Link to="/reports/opportunity-bid-due-date" className={s.item}>
                        By Bid Due Date
                      </Link>
                      <Link to="/reports/opportunity-follow-up-date" className={s.item}>
                        By Follow-up Date
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <Link to="/reports/opportunity-bid-submission-date" className={s.item}>
                        By Bid Submission Date
                      </Link>
                      <Link to="/reports/opportunity-bid-submission-status" className={s.item}>
                        By Bid Submission Status
                      </Link>
                      <Link to="/reports/opportunity-won-date" className={s.item}>
                        By Won Date
                      </Link>
                      <Link to="/reports/opportunity-lost-date" className={s.item}>
                        By Lost Date
                      </Link>
                      <Link to="/reports/opportunity-source" className={s.item}>
                        By Source
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="4">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Pipeline Reports</p>
                      <Link to="/reports/pipeline-by-stage" className={s.item}>
                        By Stage
                      </Link>
                      <Link to="/reports/pipeline-by-client" className={s.item}>
                        By Client
                      </Link>
                      <Link to="/reports/pipeline-by-user" className={s.item}>
                        By User
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Activity Reports</p>
                      <p className={s.item}>Activity By User</p>
                      <p className={s.item}>Activity By Team</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className={cn(s.settingsRow, 'g-0')}>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.settings, s.iconCell)}>
                    <FaCog className={s.icon} />
                    <p className={s.description}>System Setup</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Users & Payment</p>
                      <Link to="/admin?menu=users&tab=organization" className={s.item}>
                        Add User
                      </Link>
                      <Link to="/admin?menu=users&tab=organization" className={s.item}>
                        Manage existing users
                      </Link>
                      <Link to="/admin?menu=users&tab=organization" className={s.item}>
                        Manage quotas
                      </Link>
                      <Link to="/admin?menu=users&tab=organization" className={s.item}>
                        Manage target profits
                      </Link>
                      <Link to="/admin?menu=subscription&tab=organization" className={s.item}>
                        Subscription & payment
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>System Branding</p>
                      <Link
                        to="/admin?menu=templates&secondaryTab=logo&tab=organization"
                        className={s.item}
                      >
                        Company logo
                      </Link>
                      <Link
                        to="/admin?menu=templates&secondaryTab=html&tab=organization"
                        className={s.item}
                      >
                        Proposal templates
                      </Link>
                      <Link
                        to="/admin?menu=templates&secondaryTab=email&tab=organization"
                        className={s.item}
                      >
                        Email Templates
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Email Settings</p>
                      <Link
                        to="/admin?menu=email&secondaryTab=email&tab=organization"
                        className={s.item}
                      >
                        Step 1: Company email setup
                      </Link>
                      <Link
                        to="/admin?menu=email&secondaryTab=email&tab=organization"
                        className={s.item}
                      >
                        Step 2: Connect your personal email
                      </Link>
                      <Link
                        to="/admin?menu=templates&secondaryTab=email&tab=organization"
                        className={s.item}
                      >
                        Email Templates
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={cn(s.rightBorder, s.fullHeight)}>
                      <p className={s.columnTitle}>Notifications</p>
                      <Link to="/admin?tab=personalSettings" className={s.item}>
                        Daily notification email
                      </Link>
                      <Link
                        to="/admin?menu=opportunity&secondaryTab=html&tab=organization"
                        className={s.item}
                      >
                        Email proposal sender
                      </Link>
                      <Link
                        to="/admin?menu=opportunity&secondaryTab=html&tab=organization"
                        className={s.item}
                      >
                        Send email to PMs
                      </Link>
                      <Link
                        to="/admin?menu=opportunity&secondaryTab=html&tab=organization"
                        className={s.item}
                      >
                        Email opportunity manager
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={s.cell}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Date & Currency</p>
                      <Link
                        to="/admin?menu=currency&secondaryTab=html&tab=organization"
                        className={s.item}
                      >
                        Set your currency
                      </Link>
                      <Link
                        to="/admin?menu=currency&secondaryTab=html&tab=organization"
                        className={s.item}
                      >
                        Set your date format
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          ) : (
            <div className={s.regularUserWrapper}>
              <Row className="g-0">
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.management, s.iconCell)}>
                    <ImTree className={s.icon} />
                    <p className={s.description}>Opportunity Management</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2" className={s.marginBottom30}>
                  <div className={cn(s.cell, s.management)}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Create Opportunities</p>
                      <p onClick={() => setIsAddDealModalVisible(true)} className={s.item}>
                        Add new opportunity
                      </p>
                      <Link to="/opportunities/board" className={s.item}>
                        See existing opportunities
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="2"
                  className="ps-0 ps-sm-0 ps-md-0 ps-lg-0 ps-xl-3"
                >
                  <div className={cn(s.clients, s.iconCell)}>
                    <FaUsers className={s.icon} />
                    <p className={s.description}>Clients Management</p>
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="2"
                  className={cn('pe-0 pe-sm-0 pe-md-0 pe-lg-0 pe-xl-3', s.marginBottom30)}
                >
                  <div className={cn(s.cell, s.clients)}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Clients / Companies</p>
                      <p onClick={toggleCompanyModal} className={s.item}>
                        Add client/company
                      </p>
                      <Link to="/companies" className={s.item}>
                        See existing clients
                      </Link>
                      <p onClick={() => setIsAddContactModalVisible(true)} className={s.item}>
                        Add contact
                      </p>
                      <Link to="/contacts" className={s.item}>
                        See existing contacts
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.proposal, s.iconCell)}>
                    <AiFillFilePpt className={s.icon} />
                    <p className={s.description}>Proposal Management</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="2">
                  <div className={cn(s.cell, s.proposal)}>
                    <div className={s.fullHeight}>
                      <p className={s.columnTitle}>Proposals / Tenders</p>
                      <p onClick={() => setIsGenerateProposalVisible(true)} className={s.item}>
                        Create new proposal
                      </p>
                      <Link to="/opportunities/board" className={s.item}>
                        Upload proposal to an existing opportunity
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Container>
      </section>
      {isAddDealModalVisible && (
        <DealsModal
          showAddDealModal={isAddDealModalVisible}
          toggleAddDealModal={() => setIsAddDealModalVisible(false)}
          createDeal={createDeal}
          users={users}
          navigate={navigate}
        />
      )}
      {isGenerateProposalModalVisible && (
        <GenerateProposalModal
          isGenerateProposalModalVisible={isGenerateProposalModalVisible}
          setIsGenerateProposalVisible={setIsGenerateProposalVisible}
          setIsProgressModalVisible={setIsProgressModalVisible}
          setLoadingStep={setLoadingStep}
        />
      )}
      {isProgressModalVisible && (
        <ProgressModal loadingStep={loadingStep} isProgressModalVisible={isProgressModalVisible} />
      )}
      {isAddContactModalVisible && (
        <ContactModalContainer
          showContactModal={isAddContactModalVisible}
          toggleContactModal={() => setIsAddContactModalVisible(false)}
          actionType="CONTACT_CREATE_REQUESTED"
        />
      )}
      {showCompanyModal && (
        <CompanyModalContainer
          toggleCompanyModal={toggleCompanyModal}
          showCompanyModal={showCompanyModal}
          actionType="COMPANY_CREATE_REQUESTED"
        />
      )}
    </>
  )
}

export default withSubscriptionNotification(withHasModules(Home))
